module.exports = __webpack_public_path__ + "126596b150438767d59cccf96bee8c87.png";